import React from 'react';
import reducer from '../reducer/goods-detail/index';
import commonReducer from '../reducer/common/index';
import dishMenuCommonReducer from '../reducer/common/dish-menu';
import dishMenuReducer from '../reducer/dish-menu';
import ReducerContainer from '../helper/reducer-helper';
import GoodsDetailApplication from '../container/goods-detail/application';
import createRootApplication from '../root-application';

createRootApplication(<GoodsDetailApplication />,
  ReducerContainer.appendReducer(
    reducer,
    commonReducer,
    dishMenuCommonReducer,
    dishMenuReducer
  )
);




// WEBPACK FOOTER //
// ./src/entry/goods-detail.jsx